<mat-spinner diameter="50"></mat-spinner>